import List from './list/ReferralRequestSenderListInitialState'

const { Record } = require('immutable')

export default Record({
    list: List()
})